import Logo from "./brandLogo.svg";
import LogoOld from "./Logo.jpeg";
import Money from "./1041888.png";
import trophy from "./reshot-icon-prize-cup-7ZQ95TMUWF 1.png";
import greenwheel from "./Green.png";
import redwheel from "./Red.png";
import violetwheel from "./Volet.png";
import RedViol from "./RP.png";
import Green from "./Layer 5.png";
import Red from "./R.png";
import greenviol from "./GP.png";
import NoImage from "../Assets/No-Image-Placeholder.jpg";
import big from "../Assets/big.png";
import small from "../Assets/small.png";
import ticket from "../Assets/ticket.png";
import withdrawImage from "../Assets/withdrawImage.png";
import ProfileImage from "../Assets/2202112.png";
import aviator from "../Assets/aviator.jpg";
import mines from "../Assets/mines.png";
import plinko from "../Assets/plinko.png";
import banner1 from "../Assets/banner1.jpg";
import banner2 from "../Assets/banner2.jpg";
import a1 from "../Assets/a1.jpg";
import mines2 from "../Assets/mines2.jpg";
import plinko1 from "../Assets/plinko1.jpeg";
export const Images = {
  ProfileImage,
  Logo,
  LogoOld,
  Money,
  trophy,
  greenwheel,
  redwheel,
  violetwheel,
  RedViol,
  Green,
  Red,
  greenviol,
  NoImage,
  big,
  small,
  ticket,
  withdrawImage,
  aviator,
  mines,
  plinko,
  banner1,
  banner2,
  a1,mines2,plinko1

};
